const map = require('lodash/fp/map');
const dateFormat = require('date-fns/format');
const memoizer = require('../request-handler/utils/memoizer');


function parseOverviewData(result) {

  let oResult = [];

  if (result && result.data && result.data.tabs){
    oResult = map(parseCioList)(result.data.tabs[0].records);
  }

  // debugger;
  return JSON.stringify({
    offSet: result.data.tabs[0].offSet,
    endOfRecords:  result.data.tabs[0].endOfRecords,
    cio: oResult });

}



function parseGetArticleAttachement(result) {
  return(result);
}
  


function parseArticle(article) {
  let oResult = {
    content: "",
    attachments : []
  }

  if(article.status == "SUCCESS"){



   
    var cssStyle="<style> ul { list-style-type: none; padding-left: 0px; margin: 0px; } li { text-align: left !important; } img { margin: auto; position: absolute; top: 10; left: 0; right: 0; height: 150px; } .content { padding-top: 8px; color:#edf2f1 !important; ; margin-top: 150px; font-size: 12px; font-family: sans-serif; } </style>"


    
    oResult.content = {
      html:  cssStyle + "<div class='content' >" +  article.content + "</div>"
    };

    oResult.attachments = article.attachmentList;
  }

  return JSON.stringify(oResult);
}



function parseArticleSlug(article) {

  let oResult = {
    title: "",
    image: {
      uri : ""
    },
    desc: "",
    date:"",
    author: "",
    attachments : []
  }


  oResult.title = article.title != null ?  article.title : "" ;
  oResult.author  = article.authorName != null ?  article.authorName : '';
  oResult.image.uri = article.themeImage != null ? article.themeImage : '';
  oResult.desc = article.themeText != null ? article.themeText : "" ;
  oResult.date = (article.publishedDate !== null && article.publishedDate !=="") ? dateFormat(new Date(article.publishedDate.split(" ")[0]), 'DD MMM YYYY') : " ";
  oResult.attachments = article.attachmentList != null ? article.attachmentList  : [];

  // debugger;
  return oResult;

}
  



function parseJson(result) {

  // debugger;

  return JSON.stringify(result);

}


function parseCioList(content) {
  return {
    title: content.title != null ?  content.title : '',
    image: {
      uri : content.themeImage != null ? content.themeImage : ''
    },
    articleId: content.notificationId != null ? content.notificationId : '',
    desc: content.themeText != null ? content.themeText : '',
    hasAttachment: content.hasAttachment  != null ? content.hasAttachment  : [], 
    date: (content.date !== null && content.date !=="") ? dateFormat(new Date(content.date.split(" ")[0]), 'DD MMM YYYY') : " ",
  };


}


function serviceFactory({ api }) {
  const getCioInsightsData = memoizer()(({ roleid,count,limit,metaData }) =>
    api.getCioInsightsData(roleid,count,limit,metaData)
      .then(parseOverviewData));

  const getArticle = memoizer()(({ articleId, metaData }) =>
    api.getArticle(articleId,metaData)
      .then(parseArticleSlug)
      .then(parseJson));

  const getAttachment = memoizer()(({ attachmentId, metaData }) =>
    api.getAttachment(attachmentId,metaData)
      .then(parseJson));

  const getCioSearchsData = memoizer()(({ roleid, searchKeyword, lazyLoadingCount, pageLimit, metaData }) =>
    api.getCioSearchData(roleid,searchKeyword,lazyLoadingCount,pageLimit,metaData)
      .then(parseOverviewData));

  return {
    getCioInsightsData, getArticle, getAttachment, getCioSearchsData
  };
}

module.exports = serviceFactory;


